export default __webpack_public_path__ + "static/media/loader_white_bg.3f80a1de.gif";